module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kbfg_m2.a543ec55720e902331820ed9485e95b1.png";